import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes, Router, ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';
import { OopsComponent } from './oops/oops.component';
import { CheckoutCommon } from './pages/_brand-pages-base/base-controllers/checkout/checkout-common';
import { CheckoutCommonTC } from './pages/checkout-pages/checkout-commonTC';
import { CheckoutCommonV2 } from './pages/checkout-pages/checkout-common-v2/checkout-common-v2';
import { CheckoutCommonV3 } from './pages/checkout-pages/checkout-common-v3/checkout-common-v3';
import { WhatIsThisPage } from '../pages/what-is-this/what-is-this';
import { SafeOrderPage } from '../pages/safe-order/safe-order';
import { DestinationComponent } from './destination/destination.component';
import { UpsellDynamic } from './upsell/upsell-dynamic';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { CcpaComponent } from './ccpa/ccpa.component';
import { TermsComponent } from './terms/terms.component';
import { PageConfigDataResolver } from './resolve/page-config-data-resolve';

const US_GENERIC_MODULE_IMPORT = () => import('./upsells-downsells/upsells/us-generic/us-generic.module').then(m => m.USGenericModule);
const UPSELL_RD_MODULE_IMPORT = import('../upsellrd/upsellrd.module').then(m => m.UpsellrdModule);
const ORDER_SUCCESS_MODULE_IMPORT = import('./order-success/order-success.module').then(m => m.OrderSuccessModule);

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: OopsComponent },
  { path: 'PrivacyPolicy', component: PrivacyPolicyComponent },
  { path: 'gdpr', component: GdprComponent },
  { path: 'ccpa', component: CcpaComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'Gundry_SecureCart', component: CheckoutCommon },
  { path: 'fst/:generidUrl', component: DestinationComponent },
  { path: 'DE_Receipt_AP', data: { animation: 'enterLeavePage' }, loadChildren: () => ORDER_SUCCESS_MODULE_IMPORT },
  { path: 'upDownDyn', component: UpsellDynamic, data: { animation: 'enterLeavePage' } },

  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
  { path: 'OrderSuccess', loadChildren: () => ORDER_SUCCESS_MODULE_IMPORT },
  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
  { path: 'upsellrd', loadChildren: () => UPSELL_RD_MODULE_IMPORT },

  /* Settings explained:
   * braintreeOneTimeCheckout: true - Enables one-time checkout flow without vaulting
   * braintreeUpsellVaulting: true - Enables vaulting for upsell payments only
   * braintreeDownsellVaulting: true - Enables vaulting for downsell payments only
   * enableCyberSource: true - Enables CyberSource payment processing integration
   * braintreeEnabled: true - Enables Braintree payment processing
   * braintreeDropInEnabled: false - Disables the Braintree Drop-in UI component
   * useNewBraintreeStyles: true - Uses updated Braintree styling
   * euSpecified: false - Indicates this is not a European Union specific configuration
   * currency: 'USD' - Sets USD as the transaction currency
   * officialCurrency: 'USD' - Sets USD as the display currency
   * currencySymbol: '$' - Sets $ as the currency symbol
   * checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC,hidePaypalButton' - Enables specific checkout features:
   *   - showProductBoxVariant1: Shows variant 1 of the product box
   *   - showFeatures: Shows feature highlights
   *   - isCheckoutCommonTC: Uses CheckoutCommonTC component
   *   - hidePaypalButton: Hides the PayPal payment button
   */

  // Gundry Routes for placeholder purposes only
  { path: 'Gundry_SecureCart_250402', component: CheckoutCommonTC, data: { currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },
  { path: 'Gundry_SecureCart_PayPal', component: CheckoutCommonTC, data: { braintreeEnabled: true, enableCyberSource: true, braintreeOneTimeCheckout: true, braintreeSubscriptionSupported: true, currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },
  { path: 'Gundry_SecureCart_PayPal2', component: CheckoutCommonTC, data: { hideChromeBanner: false, braintreeEnabled: true, enableCyberSource: true, braintreeOneTimeCheckout: true, braintreeUpsellVaulting: true, braintreeSubscriptionSupported: true, currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },
  { path: 'Gundry_SecureCart_PayPal3', component: CheckoutCommonTC, data: { braintreeEnabled: true, enableCyberSource: true, braintreeOneTimeCheckout: true, braintreeDownsellVaulting: true, braintreeSubscriptionSupported: true, currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },

  { path: 'DrivenEntrepreneur_SecureCart', component: CheckoutCommonV2, data: {  enableCyberSource: false, braintreeSubscriptionSupported: true, braintreeEnabled: true, braintreeDropInEnabled: false,  euSpecified: true, currency: 'USD', braintreeCurrencyConversion: 1.00, officialCurrency: 'USD', currencySymbol: '$', braintreeCountryLabel: true } }, //DEV-50757
  { path: 'DrivenEntrepreneur_SecureCart_BumpOffer', component: CheckoutCommonV3, data: { enableCyberSource: false, braintreeSubscriptionSupported: true, braintreeEnabled: true, braintreeDropInEnabled: false, euSpecified: true, currency: 'USD', braintreeCurrencyConversion: 1.00, officialCurrency: 'USD', currencySymbol: '$', braintreeCountryLabel: true } }, //DEV-55220
  // Below routes for testing TC design checkout page
  { path: 'DrivenEntrepreneur_SecureCart_250402', component: CheckoutCommonTC, data: { currency: 'USD', officialCurrency: 'USD', currencySymbol: '$', checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },


  { path: 'Gundry_Receipt_Course_AP', data: { animation: 'enterLeavePage', thankYouTextDefault: false }, loadChildren: () => import('./order-success/order-success.module').then(m => m.OrderSuccessModule) }, //DEV-48382

  { path: 'DrivenEntrepreneur_Receipt_AP', data: { animation: 'enterLeavePage', thankYouTextDefault: false , vidalyticsEmbedId:"fvlJxetvMpTPY8Xr"}, loadChildren: () => ORDER_SUCCESS_MODULE_IMPORT }, //DEV-50757

  // DEV-55755
  { path: 'US_1-Unit-SharkProfitMachine_AP', data: { animation: 'enterLeavePage', productQuantity: 1, pageConfigPath: '../assets/page-configurations/upsells/US_1-Unit-SharkProfitMachine_AP.json' }, loadChildren: US_GENERIC_MODULE_IMPORT, resolve: { data: PageConfigDataResolver } },
  { path: 'DS_1-Unit-SharkProfitMachineInstallment_AP', data: { animation: 'enterLeavePage', productQuantity: 1, pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-SharkProfitMachineInstallment_AP.json' }, loadChildren: US_GENERIC_MODULE_IMPORT, resolve: { data: PageConfigDataResolver } },
  { path: 'US_1-Unit-SharkBusinessIntensive_AP', data: { animation: 'enterLeavePage', productQuantity: 1, pageConfigPath: '../assets/page-configurations/upsells/US_1-Unit-SharkBusinessIntensive_AP.json' }, loadChildren: US_GENERIC_MODULE_IMPORT, resolve: { data: PageConfigDataResolver } },
  { path: 'DS_1-Unit-SharkBusinessIntensiveInstallment_AP', data: { animation: 'enterLeavePage', productQuantity: 1, pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-SharkBusinessIntensiveInstallment_AP.json' }, loadChildren: US_GENERIC_MODULE_IMPORT, resolve: { data: PageConfigDataResolver } },
];


class CustomReuseStrategy extends RouteReuseStrategy {
  /**
   * Determines if a route should be detached and stored for potential reuse.
   * Returns false as we don't store routes.
   */
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Stores a detached route (not used in this implementation).
   */
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // No-op: routes are not stored
  }

  /**
   * Determines if a stored route should be attached.
   * Returns false as we don't store routes.
   */
  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Retrieves a stored route (not used in this implementation).
   */
  retrieve(_route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    return null;
  }

  /**
   * Determines whether to reuse a route when navigating.
   * On iOS devices, routes are never reused to maintain compatibility
   *
   * @param future The route being navigated to
   * @param curr The current route
   * @returns true if the route should be reused, false otherwise
   */
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    // Check if iOS with safe fallback for SSR/testing environments
    const isIOS = this.detectIOSDevice();

    if (isIOS) {
      return false; // Never reuse on iOS
    }

    // Default Angular behavior: reuse if route configs are identical
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * Detects if the current device is an iOS device.
   * Returns false if navigator is unavailable (SSR/testing).
   */
  private detectIOSDevice(): boolean {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false; // Safe fallback for SSR
    }

    // Check for iPhone, iPad, or iPod in user agent
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}

@Injectable({ providedIn: "root" })
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }]
})
export class AppRoutingModule {
  constructor(public router: Router) {
    console.log("[GH] AppRoutingModule constructor " + document.location.origin + '/assets/html/a18tests.html');
    let content = {};
    let logic = (content: any) => {
      if (Object.keys(content).length === 0) {
        console.log("[GH] Error getting upsell dynamic content");
        this.routeHandlerFinally();
        return;
      } else {
        console.log("[GH] Got upsell dynamic content", content);
      }
      for (let prop in content) {
        if (prop == "fileListStream") {
          for (const key in (content as any)[prop]) {
            if ((content as any)[prop].hasOwnProperty(key)) {
              /*  console.log(
                 `[GH] push this key? ${key}`,
                 (content as any)[prop][key]
               ); */
              //console.log('this.router.config', ...this.router.config);

              let alreayAdded = false;
              for (let i = 0; i < this.router.config.length; i++) {
                if (this.router.config[i].path == (content as any)[prop][key].url) {
                  //console.log('route already added ' + (content as any)[prop][key].url);
                  alreayAdded = true;
                  break;
                }
              }
              if (alreayAdded) {
                continue;
              }

              if (typeof (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent == 'object') {
                let isvalid = false;
                for (let i = 0; i < (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent.length; i++) {
                  //console.log('checking '+(content as any)[prop][key].url, (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i])
                  if ((window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i] == 'upDownDyn-' + (content as any)[prop][key].url + '.json') {
                    isvalid = true;
                    break;
                  }
                }
                if (!isvalid) {
                  continue;
                }
                this.router.config.push({
                  path: (content as any)[prop][key].url,
                  component: UpsellDynamic,
                  data: { animation: "enterLeavePage" },
                });
              } else {
                console.log('upsellDynamicCMSControl.dynamicPageNamesWithContent is not an array');
              }
            }
          }
        }
      }
      this.routeHandlerFinally();
    }
    if ((window as any)['upsellDynamicContent']) {
      logic((window as any)['upsellDynamicContent']);
      return;
    }
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "/assets/content/store_dynamic_upsell_control.json", false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = () => {
      if (typeof xhr.response == "string") content = JSON.parse(xhr.response);
      else if (typeof xhr.response == "object") content = xhr.response;
      logic(content);
    };
    xhr.onerror = (error) => {
      console.log(`XHR Error: ${error}`);
      this.routeHandlerFinally();
    };

    xhr.send();
  }

  routeHandlerFinally() {
    // Wildcard route TODO add a not found handler
    this.router.config.push({
      path: "**",
      component: OopsComponent,
      data: { animation: "enterLeavePage" },
    });
  }
}
